<template>
  <div class="hdo-record px-3 py-4 mb-4">
    <div
      v-if="!originalMailOrNot"
      class="text-danger py-3 px-4 rounded bg-light text-center mb-5"
    >
      <i class="fa fa-user-secret pl-3"></i>
      {{ impersonateMail.split("@")[0] }}
    </div>              

    <!-- Person not found -->
    <div v-if="!isPersonExist" class="empty-status ft-empty-status">
      <div class="icon">
        <i class="icons icon-user-unfollow"></i>
      </div>
      <div class="title">No record found for this user.</div>
    </div>

    <!-- Month grid -->
    <div v-else class="hdo-months">
      <!-- Year Select -->
      <div class="d-flex flex-column align-items-start mb-4 gap-1">
        <select
          class="form-control hdo-form-control w-auto"
          v-model="yearSelected"
          @change="retrieveHdo()"
        >
          <option :value="yearOptions[0]">{{ yearOptions[0] }}</option>
          <option :value="yearOptions[1]">{{ yearOptions[1] }}</option>
        </select>
      </div>

      <div
        v-for="month in hdoRecords"
        :key="month.sequence"
        class="hdo-card"
      >
        <div class="hdo-card-header" :class="{ 'has-data': month.dates.length }">
          <span class="hdo-month-name">{{ $moment(month.sequence, 'M').format('MMMM') }}</span>
          <span v-if="month.dates.length" class="hdo-trip-pill">
            {{ month.dates.length }} {{ month.dates.length === 1 ? 'Day' : 'Days' }}
          </span>
        </div>

        <div v-if="!month.dates.length" class="hdo-empty-row">
          —No record in {{ $moment(`${yearSelected}-${month.sequence}`, 'YYYY-M').format('MMM YYYY') }}—
        </div>

        <div v-if="month.dates.length" class="hdo-dates-row">
          <span v-for="(date) in month.dates" class="hdo-trip-date">
            {{ $moment(date).format('MMM DD YYYY') }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
  name: 'HDORecord',
  data: () => ({
    hdoRecords: [],
    yearOptions: [dayjs().format('YYYY'), dayjs().subtract(1, 'year').format('YYYY')],
    yearSelected: '',
    searchMail: localStorage.getItem('mail') || '', 
    isPersonExist: true
  }),
  computed: {
    impersonateMail() {
      return this.$store.getters.impersonateMail;
    },
    originalMailOrNot() {
      if (this.impersonateMail != "") {
        return this.impersonateMail === localStorage.getItem("mail");
      } else {
        return true;
      }
    }
  },
  methods: {
    retrieveHdo(mail) {
      this.hdoRecords = []
      this.searchMail = mail ? mail.split('@')[0] : ''
      const impersonate = this.impersonateMail ? this.impersonateMail.split('@')[0] : ''
      const searchId = this.searchMail || impersonate
      this.getDayOff(localStorage.getItem('access_token'), searchId, this.yearSelected)
        .then(resp => {
          this.isPersonExist = true
          this.hdoRecords = resp.data.data.holiday
        })
        .catch(err => {
          console.log('err', err)
          this.isPersonExist = false
        })
    },  
    groupedRows(data) {
      const size = 4
      const rows = []
      for (let i = 0; i < data.length; i += size) {
        rows.push(data.slice(i, i + size))
      }
      return rows
    },
  },
  watch: {
    impersonateMail(to) {
      this.retrieveHdo(to);
    },
  },
  created() {
    this.yearSelected = this.yearOptions[0];
    this.retrieveHdo();
  },
};
</script>

<style lang="scss" scoped>
.hdo-record { 
  max-width: 1000px; 
  margin: 0 auto; 
}

.hdo-months {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.hdo-card {
  border: 1px solid #e8e8e8;
  border-radius: 10px;
  overflow: hidden;
  min-width: 0;
}

.hdo-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 15px;
  border-bottom: 1px solid #f0f0f0;
  background: #EBE6E0;
  flex-wrap: wrap;
  gap: 4px;
}

.hdo-card-header.has-data {
  background: #EBE6E0;
}

.hdo-month-name {
  font-size: 16px;
  font-weight: bold;
  padding: 3px 10px;
  border-radius: 99px;
  background: #FFFFFF;
  color: #555;
}

.hdo-trip-pill {
  font-size: 16px;
  color: #888;
}

.hdo-empty-row {
  text-align: center;
  color: #bbb;
  font-style: italic;
  font-size: 15px;
  padding: 20px;
}

.hdo-trip-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.hdo-trip-num {
  font-size: 16px;
  color: #aaa;
  min-width: 24px;
}

.hdo-trip-date {
  font-size: 15px;
  font-weight: 500;
  color: #444;
  background: #F5F3F0;
  padding: 8px 10px;
  border-radius: 6px;
}

.hdo-dates-row{
  display: grid;
  justify-content: space-evenly;
  grid-template-columns: repeat(auto-fill, 120px);
  gap: 1.5rem;
  padding: 1.5rem 1.0rem;
}

.hdo-form-control {
  padding: 0 38px 0 15px !important;
}

.ft-empty-status {
  padding: 150px 0 0 0;
}
</style>
